<script setup>
import { computed, toRefs, defineAsyncComponent } from 'vue';
import { useChangeCase } from '@vueuse/integrations/useChangeCase';
import PIcon from '@/components/ProxifyUI/PIcon.vue';

const props = defineProps({
  color: {
    type: String,
    default: '',
  },
  left: {
    type: Boolean,
    default: false,
  },
  right: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: '',
  },
  name: {
    type: String,
    default: '',
  },
  customClass: {
    type: String,
  },
});
</script>

<template>
  <PIcon
    :color="color"
    :left="left"
    :right="right"
    :size="size"
    :custom-class="customClass"
    :class="`icon-${name}`"
  ></PIcon>
</template>
